import React from "react";
import { noAutoTranslateUserTextProps } from "./i18n";

/** 品牌名（Logo 文案，各语言均不翻译） */
export const BRAND_NAME = "Gamee";

/** 提交给 i18n-jsautotranslate 的忽略词 */
export const BRAND_IGNORE_TERMS = [
  "Gamee",
  "gamee",
  "GAMEE",
  "Gamee Store",
];

export function configureBrandTranslateIgnore(translate) {
  if (!translate?.ignore) return;

  if (Array.isArray(translate.ignore.text)) {
    for (const term of BRAND_IGNORE_TERMS) {
      if (!translate.ignore.text.includes(term)) {
        translate.ignore.text.push(term);
      }
    }
  }

  const classList = translate.ignore.class?.data;
  if (Array.isArray(classList) && !classList.includes("gamee-brand")) {
    classList.push("gamee-brand");
  }
}

export function GameeBrand({ className = "" }) {
  return (
    <span
      className={["gamee-brand", "ignore", "notranslate", className]
        .filter(Boolean)
        .join(" ")}
      {...noAutoTranslateUserTextProps}
    >
      {BRAND_NAME}
    </span>
  );
}

/** 将文案中的 Gamee 包裹为不翻译品牌节点 */
export function TextWithGameeBrand({ text, className = "" }) {
  const raw = String(text ?? "");
  const parts = raw.split(/(Gamee|gamee|GAMEE)/g);
  if (parts.length === 1) {
    return className ? <span className={className}>{raw}</span> : raw;
  }
  return (
    <span className={className || undefined}>
      {parts.map((part, index) =>
        /^gamee$/i.test(part) ? (
          <GameeBrand key={`brand-${index}`} />
        ) : (
          part
        ),
      )}
    </span>
  );
}
